import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { SiteSettingsRestConnectorService } from './services/site-settings-rest-connector.service';
import { SiteSettingsService, SiteSettingLanguageService } from './services/site-settings.service';
import { SiteSettingsEffects } from './state/site-settings-effects';
import { siteSettingsReducer } from './state/site-settings.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('siteSettings', siteSettingsReducer),
    EffectsModule.forFeature([
      SiteSettingsEffects,
    ]),
    CommonModule,
  ],
  providers:[
    SiteSettingsService,
    SiteSettingLanguageService,
    SiteSettingsRestConnectorService,
    SiteSettingsEffects,
  ],
  declarations: [],
})
export class SiteSettingsModule { }
